import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetCurrencyBooksQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetCurrencyBooksQuery = { __typename?: "query_root" } & {
  currency_books: Array<
    { __typename?: "currency_books" } & Pick<
      Types.Currency_Books,
      "id" | "is_archived" | "name"
    > & {
        business_unit: { __typename?: "business_units" } & Pick<
          Types.Business_Units,
          "id" | "name"
        >;
      }
  >;
};

export const GetCurrencyBooksDocument = gql`
  query GetCurrencyBooks {
    currency_books {
      id
      is_archived
      name
      business_unit {
        id
        name
      }
    }
  }
`;

export function useGetCurrencyBooksQuery(
  options: Omit<Urql.UseQueryArgs<GetCurrencyBooksQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetCurrencyBooksQuery>({
    query: GetCurrencyBooksDocument,
    ...options,
  });
}
